import { useCallback, useEffect, useRef } from 'react';
import Raven from 'raven-js';
import { MagpieConnection } from 'magpie-lib/connection';
import { useNavigationComponent } from 'navigation-components/application/hooks';
import { connectionSettingsModalComponentDef } from 'navigation-components/config';
import { closeModal, ConnectionSettingsModalIFrameTopic, publishCloseModal } from '../components/internal/ConnectionSettingsModalIFrame';
import { unsubscribeAll } from '../utils/unsubscribeAll';
import { trackEvent, EventNames } from '../utils/tracker';
export function useConnectionSettingsModal({
  onClose
} = {}) {
  const lastClosedTime = useRef(0);
  const navComponent = useNavigationComponent({
    componentDef: connectionSettingsModalComponentDef
  });

  // begin preloading after a short delay so the magpie connection is ready
  useEffect(() => {
    const timeoutId = window.setTimeout(async () => {
      const componentState = await navComponent.getState();
      if (componentState.isOpen) return;
      await navComponent.hide();
    }, 1000);
    return () => window.clearTimeout(timeoutId);
  }, [navComponent]);
  useEffect(() => {
    const topic = MagpieConnection.get().forTopic(ConnectionSettingsModalIFrameTopic);
    return unsubscribeAll(topic.on(closeModal.getType(), () => {
      lastClosedTime.current = new Date().getTime();
      onClose === null || onClose === void 0 || onClose();
    }));
  }, [onClose]);
  const open = useCallback((appId, options) => {
    // attempting to open while still closing makes the modal unresponsive,
    // so guard against rapid toggles
    if (new Date().getTime() - lastClosedTime.current < 500) return;
    navComponent.setProps(Object.assign({
      appId
    }, options)).then(() => navComponent.show().then(() => trackEvent(EventNames.MODAL_INTERACTION, {
      action: 'open-embedded-connections-modal',
      appId
    })).catch(err => {
      Raven.captureException(new Error('Failed to show connections settings modal', {
        cause: err
      }), {
        tags: {
          library_name: 'connections-embed-lib'
        }
      });
    })).catch(err => {
      Raven.captureException(new Error('Failed to show connections settings modal', {
        cause: err
      }), {
        tags: {
          library_name: 'connections-embed-lib'
        }
      });
    });
  }, [navComponent]);
  return {
    open,
    close: publishCloseModal
  };
}